function isNull(value: any): value is null {
    return value === null;
}
function isUndefined(value: any): value is undefined {
    return value === undefined;
}
export function hasValue<T>(o: T | undefined | null): o is T {
    if (isNull(o)) {
        return false;
    } else if (isUndefined(o)) {
        return false;
    }
    return true;
}
export function hasStringValue(s: string | null | undefined): s is string {
    if (!hasValue(s)) {
        return false;
    } else if (s === '') {
        return false;
    }
    return true;
}
